import React, { useEffect, useState } from "react";

function AdminUserManager({ token }) {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ username: "", password: "", name: "", role: "user" });
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState("");

  // Lấy danh sách user
  const fetchUsers = async () => {
    const res = await fetch("https://api.diemdanhkhucgk88.com/api/users", {
      headers: { Authorization: "Bearer " + token }
    });
    const data = await res.json();
    setUsers(data);
  };

  useEffect(() => { fetchUsers(); }, []);

  // Thêm hoặc cập nhật user
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (editId) {
      // Sửa
      const res = await fetch(`https://api.diemdanhkhucgk88.com/api/users/${editId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      setMessage(data.message);
    } else {
      // Thêm
      const res = await fetch("https://api.diemdanhkhucgk88.com/api/users", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      setMessage(data.message);
    }
    setForm({ username: "", password: "", name: "", role: "user" });
    setEditId(null);
    fetchUsers();
  };

  // Xóa user
  const handleDelete = async (id) => {
    if (!window.confirm("Bạn chắc chắn muốn xóa?")) return;
    const res = await fetch(`https://api.diemdanhkhucgk88.com/api/users/${id}`, {
      method: "DELETE",
      headers: { Authorization: "Bearer " + token }
    });
    const data = await res.json();
    setMessage(data.message);
    fetchUsers();
  };

  // Chọn user để sửa
  const handleEdit = (user) => {
    setEditId(user._id);
    setForm({ username: user.username, password: "", name: user.name, role: user.role });
  };

  return (
    <div className="admin-user-manager">
      <h2>Quản lý tài khoản</h2>
      {message && <div className="message">{message}</div>}
      <form onSubmit={handleSubmit} className="user-form">
        <input
          type="text"
          placeholder="Tài khoản"
          value={form.username}
          onChange={e => setForm({ ...form, username: e.target.value })}
          required
          disabled={!!editId}
        />
        <input
          type="password"
          placeholder={editId ? "Đổi mật khẩu (bỏ qua nếu không đổi)" : "Mật khẩu"}
          value={form.password}
          onChange={e => setForm({ ...form, password: e.target.value })}
          required={!editId}
        />
        <input
          type="text"
          placeholder="Tên hiển thị"
          value={form.name}
          onChange={e => setForm({ ...form, name: e.target.value })}
          required
        />
        <select
          value={form.role}
          onChange={e => setForm({ ...form, role: e.target.value })}
          disabled={!!editId}
        >
          <option value="user">User</option>
        </select>
        <button type="submit">{editId ? "Cập nhật" : "Thêm mới"}</button>
        {editId && <button type="button" onClick={() => { setEditId(null); setForm({ username: "", password: "", name: "", role: "user" }); }}>Hủy</button>}
      </form>
      <table className="user-table">
        <thead>
          <tr>
            <th>Tài khoản</th>
            <th>Tên</th>
            <th>Quyền</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u._id}>
              <td>{u.username}</td>
              <td>{u.name}</td>
              <td>{u.role}</td>
              <td>
                <button onClick={() => handleEdit(u)}>Sửa</button>
                <button onClick={() => handleDelete(u._id)}>Xóa</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminUserManager;
